<div class="preview-container" [ngClass]="{ 'with-button': removeButton, 'offers': colors === 'offers' }">
  <span (click)="!isCarousel ? showImage(photoPath) : null" *ngIf="photoPath || rawData" class="image-container">
    <img
      *ngIf="rawData; else fromPath"
      [src]="rawData"
      (load)="loaded = true"
      [hidden]="!loaded"
      class="new"
      [matTooltip]="'tooltip.addImage' | loc"
    />
    <ng-template #fromPath>
      <img [src]="photoPath | getStorageURL" (load)="loaded = true" [hidden]="!loaded" />
    </ng-template>
    <span class="size" *ngIf="size">{{ size | fileSize }}</span>
    <app-loader class="loader" [color]="colors" *ngIf="!loaded"></app-loader>
  </span>
  <a *ngIf="removeButton" class="remove-button" (click)="onRemove.emit()"></a>
</div>
